export default "__VITE_ASSET__F3fC_0d0__"